import { Box } from '@mui/material';
import { alturaContainer } from 'utils/constants';

const HomeContainer = ({ children }: any) => {
  return (
    <Box
      mx="auto"
      mt="50px"
      mb="280px"
      sx={{ backgroundColor: '#f7f7f7' }}
      height="100%"
      minHeight={alturaContainer}
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      className="homeContainer"
    >
      {children}
    </Box>
  );
};

export default HomeContainer;
